<script>
// 🚨 This component is deprecated. Please use fluent-icon instead.
import { hasEmojiSupport } from 'shared/helpers/emoji';
import { mapGetters } from 'vuex';

export default {
  props: {
    icon: { type: String, default: '' },
    iconSize: { type: [Number, String], default: 20 },
    emoji: { type: String, default: '' },
  },
  computed: {
    ...mapGetters({ uiSettings: 'getUISettings' }),
    isIconTypeEmoji() {
      const { icon_type: iconType } = this.uiSettings || {};
      return iconType === 'emoji';
    },
    showEmoji() {
      return this.isIconTypeEmoji && this.emoji && hasEmojiSupport(this.emoji);
    },
    showIcon() {
      return !this.showEmoji && this.icon;
    },
    isPhosphorIcon() {
      return this.icon && this.icon.startsWith('i-ph-');
    },
    iconContent() {
      return this.showEmoji ? this.emoji : '';
    },
    className() {
      return {
        'icon--emoji': this.showEmoji,
        'icon--font': this.showIcon,
        [this.icon]: this.showIcon && this.isPhosphorIcon,
      };
    },
    phosphorIconStyle() {
      return {
        width: `${this.iconSize}px`,
        height: `${this.iconSize}px`,
      };
    },
  },
};
</script>

<template>
  <i v-if="showEmoji" :class="className">{{ iconContent }}</i>
  <span
    v-else-if="showIcon && isPhosphorIcon"
    class="flex-shrink-0 icon--font"
    :class="[icon]"
    :style="phosphorIconStyle"
  />
  <fluent-icon
    v-else-if="showIcon"
    :size="iconSize"
    :icon="icon"
    class="flex-shrink-0"
    :class="className"
  />
</template>

<style lang="scss" scoped>
.icon--emoji {
  font-style: normal;
}
</style>
